/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e7db7c00976920081e9017439698f8fd78ed5bea";
